export enum GetTransactionsType{
    PENDING = `PENDING`,
    ASSIGNED =`ASSIGNED`,
    COMPLETED =`COMPLETED`
}